import React, { useState, useEffect } from "react";
import {
  Button, Modal, ModalHeader, ModalBody,
  ModalFooter,
  FormGroup,
  Row,
  Col,
  Input,
  Label
} from "reactstrap";


import LoaderUI from '../../../../../components/common/loader';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import DatePicker from "react-datepicker";
import { generateCSV } from "../../../../../context/actions/document";
import moment from 'moment';
toast.configure();

const CsvModal = ({ closeModal, showModel, _toggle, addOperator, updateOperator, operatorDetail, disabled, locations, lodder }) => {

  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const history = useHistory()
  const dispatch = useDispatch()
  const [disable, setDisable] = useState(false)
  const [title, setTitle] = useState('Download')
  const [error, setError] = useState('')
  const [height, setHeight] = useState('0')
  //convert response from api to a file then download
  const downloadCSV = async (res) => {
    const data = res;
    const blob = new Blob([data], { type: "data:text/csv;charset=utf-8," });
    const blobURL = window.URL.createObjectURL(blob);

    // Create new tag for download file
    const anchor = document.createElement("a");
    anchor.download = "Report from " + moment(startDate).format('MM-DD-YYYY') + " To " + moment(endDate).format('MM-DD-YYYY') + ".csv";
    anchor.href = blobURL;
    anchor.dataset.downloadurl = ["text/csv", anchor.download, anchor.href].join(
      ":"
    );

    anchor.click();

    // Remove URL.createObjectURL. The browser should not save the reference to the file.
    setTimeout(() => {
      // For Firefox it is necessary to delay revoking the ObjectURL
      URL.revokeObjectURL(blobURL);
    }, 100);
  };

  const download = () => {
    console.log('startDate====',startDate);
    setDisable(true)
    if (title == "Download Anyway") {
      setError('')
      dispatch(generateCSV({ startDate: startDate, endDate: endDate, notValidated: true }, async (response) => {
        if (response && !response.errors) {
          setDisable(false)
          setTitle("Download")
          downloadCSV(response)
        }
        else {
          toast.error(response.errors.msg)
          setDisable(false)
          setTitle("Download")
        }
      })
      );
    }
    else {
      dispatch(generateCSV({ startDate: startDate, endDate: endDate }, async (response) => {
        if (response && !response.errors) {
          setDisable(false)
          downloadCSV(response)
        }
        else if (response.messageID) {
          setDisable(false)
        }
        else {
          setError(response.errors.msg)
          setTitle("Download Anyway")
          setDisable(false)
        }
      })
      );
    }
  };

  const close = () => {
    closeModal()
    setTitle("Download")
    setDisable(false)
    setError('')
    setHeight('0')
    setStartDate(new Date()) //sets date to default by today's date
    setEndDate(new Date())   //sets date to default by today's date
  };
  return (
    <>
      <Modal isOpen={showModel}
        backdrop="static">
        <ModalHeader>
          Select a date range to download CSV
        </ModalHeader>
        <ModalBody style={{ minHeight: height }}>
          {/* <div className="date-time-dropdown-blc d-flex flex-column align-items-center position-absolute"> */}
          <div className="row">
            <div className="col-6">
              Start Date
              <DatePicker
                selected={startDate}
                onChange={(e) => { console.log(e);setStartDate(new Date(e)); setHeight('0'); }}
                // onFocus={() => { setTimeout(()=>setHeight('300px'),0) }}
                onFocus={() => { setHeight('300px') }}
                onBlur={() => { setHeight('0') }}
                maxDate={new Date()}
                className="date-range form-control"
                placeholderText="Start Date"
              />
            </div>
            <div className="col-6">
              End Date
              <DatePicker
                selected={endDate}
                onChange={(e) => { setEndDate(new Date(e)); setHeight('0') }}
                onFocus={() => { setHeight('300px') }}
                onBlur={() => { setHeight('0') }}
                maxDate={new Date()}
                minDate={startDate}
                className="date-range form-control"
                placeholderText="End Date"
              />
            </div>
          </div>
          {/* </div> */}
        </ModalBody>
        <ModalFooter>
          <p style={{ color: "red" }}>{error}</p>
          <Button color="link" onClick={download} disabled={disable} className="cancel-btn">
            {title}
          </Button>
          <Button
            // disabled={disabled}
            color="secondary"
            onClick={close}
          >
            Close
          </Button>
        </ModalFooter>

      </Modal>
      {lodder && <LoaderUI className="modal-overlay-level-1" overlay />}
    </>
  );
};

export default CsvModal;
